function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "WanBridge",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 56759"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.85162 6.48193L8.11142 17.5779H10.6771L7.41823 6.48193H4.85162Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-2",
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.73731 10.6327C4.89504 10.6327 0.970337 13.7421 0.970337 17.5785H5.46601C5.46601 14.3577 8.23328 11.6505 11.9856 10.8637C11.2678 10.7137 10.5144 10.6327 9.73731 10.6327Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2332 10.6327C13.4561 10.6327 12.7027 10.7137 11.9858 10.8637C15.7381 11.6505 18.5045 14.3577 18.5045 17.5785H23.0002C23.0002 13.7421 19.0755 10.6327 14.2332 10.6327Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-6",
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2321 17.5783H15.7987L19.0576 6.48132H16.491L13.2321 17.5783Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-8",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7861 17.5784H13.2249L10.6765 8.90344H13.2386L15.7861 17.5784Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-10",
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.12251 17.5784H10.6846L13.232 8.90344H10.67L8.12251 17.5784Z",
  fill: "none"
})));

var SvgBridge = function SvgBridge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBridge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bridge.20c73e8f.svg";
export { ForwardRef as ReactComponent };